import React from 'react'
import BaseStep from '../BaseStep'
import Back from '../commons/Back'
import CurrencyInput from '../../../../components/CurrencyInput'
import ContinueButton from '../../../../components/ContinueButton'
import {numberAddCommas} from '../../../../servos/formValidations'
import StringInput from '../../../LoanApplication/components/commons/StringInput'

class CashOutReason extends BaseStep {
  state = {
    cashOutReason: '',
    cashOutAmount: null
  }

  componentDidMount() {
    const { cashOutReason, cashOutAmount } = this.props

    this.setState({ cashOutReason, cashOutAmount })
  }

  onContinue = () => {
    this.props.onChoice({ ...this.state })
  }

  renderContinue() {
      const { cashOutReason, cashOutAmount } = this.state

      return(
        <div className='text-center'>
          <ContinueButton
            enabled={ cashOutReason && cashOutAmount }
            onClick={ this.onContinue }
          />
        </div>
      )
  }

  render() {
    const { cashOutReason, cashOutAmount} = this.state

    return (
      <div className='container product container'>
        <h3 className='onboarding-title text-center'>
            Why do you want to get cash out?
        </h3>
        <div className='card card-single'>
          <div className='card-body'>
            <div className='form-group form-group-lg'>
              <label>Please enter a reason</label>
              <StringInput
                size='large'
                defaultValue={cashOutReason || ''}
                placeholder='e.g car, home renovation, holiday'
                onChange={ cashOutReason => this.setState({ cashOutReason })}
              />
            </div>

            <div className='form-group form-group-lg'>
              <label>How much do you want to get out?</label>
              <CurrencyInput
                size='large'
                onChange={ cashOutAmount => this.setState({ cashOutAmount })}
                defaultValue={ numberAddCommas(cashOutAmount) }
                placeholder='Enter amount'
              >
              </CurrencyInput>
            </div>
          </div>
        </div>
        <div className='card card-invisible'>
          { this.renderContinue() }
          <Back onGoBack={this.props.onGoBack} />
        </div>
        <br/>
        <br/>
      </div>
    )
  }
}

export default CashOutReason
